// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  meterKey: __t.string().primaryKey().name("meter_key"),
  opId: __t.u64().name("op_id"),
  kind: __t.string(),
  identity: __t.identity(),
  accMs: __t.u32().name("acc_ms"),
  lastBeatMs: __t.f64().name("last_beat_ms"),
  lastX: __t.f64().name("last_x"),
  lastY: __t.f64().name("last_y"),
  lastZ: __t.f64().name("last_z"),
  seq: __t.u32(),
  shipId: __t.u64().name("ship_id"),
  reason: __t.string(),
  updatedAt: __t.timestamp().name("updated_at"),
});
